<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 14:51:10
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-02-07 11:52:40
-->
<template>
  <div class="subject">
    <div class="title">
      配置考试科目
      <el-button
        v-if="!isReadOnly"
        icon="el-icon-circle-plus-outline"
        type="primary"
        @click="addSubject"
      >
        增加
      </el-button>
    </div>
    <div class="subject-table">
      <table-list
        :loading="loading"
        :data="subjectList"
        :columns="columns(this)"
        :operates="operates(this)"
        :options="{ operatesWidth: 180 }"
      ></table-list>
    </div>
    <el-dialog
      class="subjectAddDialog"
      :title="title"
      :visible.sync="subjectAddVisible"
      :before-close="handleCloseDialog"
      width="620px"
    >
      <el-form
        v-if="subjectAddVisible"
        ref="subjectForm"
        class="subjectForm"
        :model="subjectForm"
        :rules="subjectRules"
        label-width="130px"
      >
        <el-form-item label="类型：" prop="subjectType">
          <el-select v-model="subjectForm.subjectType" placeholder="请选择类型">
            <el-option label="实操" :value="1"></el-option>
            <el-option label="理论" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职业/等级：" prop="job">
          <el-cascader
            v-model="subjectForm.job"
            placeholder="请选择职业/等级"
            :options="jobLevelList"
            :props="{
              value: 'id',
              label: 'jobName',
              children: 'levelList',
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="考试科目名称：" prop="examSubjectName">
          <el-input
            v-model="subjectForm.examSubjectName"
            placeholder="请输入考试科目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="考试时间：" prop="examTime">
          <el-date-picker
            v-model="subjectForm.examTime"
            type="datetimerange"
            placeholder="选择考试时间"
            style="width: 100%;"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否需要人脸识别">
          <el-switch v-model="subjectForm.photoFlag"></el-switch>
        </el-form-item>
        <el-form-item v-if="subjectForm.photoFlag" label="人脸识别白名单">
          <el-input v-model="subjectForm.photoWhiteList" placeholder="人脸识别白名单(中文逗号分隔)"></el-input>
        </el-form-item>
        <el-form-item label="描述：" prop="subjectDescribe">
          <el-input
            v-model="subjectForm.subjectDescribe"
            type="textarea"
            :rows="4"
            maxlength="255"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!isReadOnly">
          <el-button type="primary" @click="handleSubjectSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <AddFromPaper ref="AddFromPaper" @success="getSubjectList" />
  </div>
</template>
<script>
// 表格列配置
const columns = () => [
  {
    prop: 'examSubjectName',
    label: '考试科目',
    minWidth: 200,
    twoLines: true,
  },
  {
    prop: 'paperId',
    label: '使用试卷ID',
    minWidth: 90,
  },
  {
    prop: 'paperTitle',
    label: '使用试卷名称',
    minWidth: 200,
    twoLines: true,
  },
  {
    prop: 'randomCode',
    label: '动态码',
  },
  {
    prop: 'jobName',
    label: '职业',
    minWidth: 160,
  },
  {
    prop: 'jobLevel',
    label: '级别',
    minWidth: 60,
  },
  {
    prop: 'subjectTypeName',
    label: '类型',
    minWidth: 60,
  },
  {
    label: '考试时间',
    minWidth: 210,
    render: (h, { row }) => {
      return [
        row.examBeginTime
          ? h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                },
              },
              [
                h('img', {
                  style: {
                    marginRight: '3px',
                  },
                  domProps: { src: require('@/assets/start.png') },
                }),
                h('span', row.examBeginTime),
              ],
            )
          : null,
        row.examEndTime
          ? h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                },
              },
              [
                h('img', {
                  style: {
                    marginRight: '3px',
                  },
                  domProps: { src: require('@/assets/end.png') },
                }),
                h('span', row.examEndTime),
              ],
            )
          : null,
      ]
    },
  },
  {
    prop: 'userName',
    label: '创建人',
    minWidth: 70,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 150,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleEdit,
    label: '编辑',
    isShow: () => !_this.isReadOnly,
  },
  {
    method: _this.handleConfigPaper,
    label: '配置试卷',
    isShow: () => !_this.isReadOnly,
  },
  {
    method: _this.handleDelete,
    label: '删除',
    isShow: () => !_this.isReadOnly,
  },
  {
    method: _this.handleRead,
    label: '查看',
    isShow: () => _this.isReadOnly,
  },
]
import TableList from '@/components/TableList'
import {
  examSubjectCreate,
  filterJobLevel,
  examSubjectGetList,
  examSubjectDel,
  examPlanSubjectDetail,
  examPlanSubJectEdit,
} from '@/api/exam'
import AddFromPaper from './AddFromPaper'
import to from 'await-to'
export default {
  name: 'Subject',
  components: { TableList, AddFromPaper },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      subjectList: [],
      columns,
      operates,
      subjectAddVisible: false,
      subjectForm: {},
      subjectRules: {
        subjectType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        job: [{ required: true, message: '请选择职业/等级', trigger: 'change' }],
        examSubjectName: [{ required: true, message: '请输入考试科目名称', trigger: 'change' }],
        examTime: [{ required: true, message: '请选择考试时间', trigger: 'change' }],
      },
      jobLevelList: [],
      title: '',
      dialogShow: 0,
    }
  },
  mounted() {
    this.getSubjectList()
    this.getJobLevelList()
  },
  methods: {
    async getSubjectList() {
      const [res, err] = await to(
        examSubjectGetList({ planId: this.$route.params.id - 0, size: 100, current: 1 }),
      )
      if (err) return this.$message.warning(err.msg)
      this.subjectList = res.data.list
    },
    async getJobLevelList() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    addSubject() {
      this.title = '添加考试科目'
      this.dialogShow = 1
      this.subjectForm = {}
      this.subjectAddVisible = true
    },
    async handleAdd() {
      this.subjectForm.jobId = this.subjectForm.job[0]
      this.subjectForm.jobLevel = this.subjectForm.job[1]
      this.$refs.subjectForm.validate(async valid => {
        if (valid) {
          const [, err] = await to(
            examSubjectCreate({
              ...this.subjectForm,
              examBeginTime: this.subjectForm.examTime[0],
              examEndTime: this.subjectForm.examTime[1],
              planId: this.$route.params.id - 0,
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('添加成功')
          this.subjectAddVisible = false
          this.getSubjectList()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async handleConfigPaper(row) {
      this.$refs.AddFromPaper.show(row.id)
    },
    handleCloseDialog() {
      this.dialogShow = 0
      this.subjectForm = {}
      this.subjectAddVisible = false
    },
    handleSubjectSubmit() {
      if (this.dialogShow == 1) {
        this.handleAdd()
      } else if (this.dialogShow == 2) {
        this.handleEditFn()
      }
    },
    //编辑
    handleEdit(row) {
      this.title = '编辑考试科目'
      this.dialogShow = 2
      this.subjectForm = {}
      this.subjectAddVisible = true
      this.handleGetSubjectInfoFn(row.id)
    },
    handleRead(row) {
      this.title = '查看考试科目'
      this.dialogShow = 2
      this.subjectForm = {}
      this.subjectAddVisible = true
      this.handleGetSubjectInfoFn(row.id)
    },
    async handleGetSubjectInfoFn(id) {
      const [res, err] = await to(examPlanSubjectDetail({ subjectId: id }))
      if (err) return this.$message.warning(err.msg)
      this.subjectForm = res.data
      this.subjectForm.job = [String(res.data.jobId), res.data.jobLevel]
      this.subjectForm.examTime = [res.data.examBeginTime, res.data.examEndTime]
    },
    async handleEditFn() {
      this.subjectForm.jobId = this.subjectForm.job[0]
      this.subjectForm.jobLevel = this.subjectForm.job[1]
      this.subjectForm.examBeginTime = this.subjectForm.examTime[0]
      this.subjectForm.examEndTime = this.subjectForm.examTime[1]
      this.$refs.subjectForm.validate(async valid => {
        if (valid) {
          const [, err] = await to(
            examPlanSubJectEdit({
              ...this.subjectForm,
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('编辑成功')
          this.subjectAddVisible = false
          this.getSubjectList()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除
    async handleDelete(row) {
      this.$confirm('你确认要删除吗?', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(
            examSubjectDel({
              planId: this.$route.params.id,
              id: row.id,
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getSubjectList()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.subject {
  height: 100%;
  .title {
    height: 78px;
    line-height: 78px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #e8ebf2;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-button {
      width: 80px;
      height: 36px;
      background: #3671bf;
      border-radius: 2px;
    }
  }
  .subject-table {
    padding: 20px;
    height: calc(100% - 108px);
  }
  .subjectAddDialog {
    /deep/.el-form-item {
      margin-bottom: 30px;
      .el-input,
      .el-select,
      .el-cascader,
      .el-textarea {
        width: 440px !important;
        .el-input__inner,
        .el-textarea__inner {
          border-radius: 2px;
        }
        input {
          height: 40px;
        }
      }
      .el-date-editor {
        width: 440px !important;
        border-radius: 2px;
      }
      .el-button {
        width: 100px;
        height: 40px;
        background: #3671bf;
        border-radius: 4px !important;
      }
    }
  }
}
</style>
